/** Escapes special characters so you can treat the string as a literal when dynamically building a regex.
 *
 * Drawn from MDN: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#escaping
 * As pointed to from StackOverflow: https://stackoverflow.com/a/6969486/72508
 */
export default function stringEscapedForRegExp(string: string): string {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // $& means the whole matched string
}
